<template>
  <div id="genres-info">
    <b-collapse :id="collapseId"
                :visible="false"
                class="genres-info-collapse"
    >
      <div class="genres-description">
        <div v-if="selectedGenres.length > 0" class="genres-description__inner">
          <div class="genres-description-row fade-in-top-fast">
            <template v-for="genre in selectedGenres">
              <div v-if="checkDescription(genre)"
                   :key="genre.id"
                   class="genres-description-row__col"
              >
                <h2>{{ genre.name }}</h2>
                <div class="genres-description-row__col__content" v-html="genre.description" />
              </div>
            </template>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: "GenresInfo",

  props: {
    collapseId: {
      type: String,
      required: true
    },
  },

  computed: {
    ...mapState({
      selectedGenres: state => state.selectedGenres,
    })
  },

  methods: {
    checkDescription(genre) {
      return genre.description.length > 0;
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/sass/abstracts/_variables.scss";

.genres-info-collapse {
  top: 0;
  position: fixed;
  width: 100%;
  z-index: 1;
}

.genres-description {
  height: calc(100vh - 200px);
  overflow-y: scroll;
  margin-top: 200px;
  background-color: $c_light_grey_fill;
  @include media-breakpoint-down(lg) {
    height: calc(100vh - 240px);
    margin-top: 240px;
  }

  &__inner {
    max-width: 1167px;
    margin: 0 auto;
    padding: 40px 28px;
    @include media-breakpoint-down(lg) {
      padding: 40px 20px 80px 20px;
    }
    @include media-breakpoint-up(xxxl) {
      max-width: 100%;
      padding: 40px 20px;
    }

    .genres-description-row {
      display: flex;
      flex-flow: row wrap;
      margin: 0 -20px;

      &__col {
        flex: 0 0 33.333%;
        padding: 0 20px;
        margin-bottom: 40px;
        @include media-breakpoint-down(lg) {
          flex: 0 0 100%;
        }

        h2 {
          @include font-16-md;
          margin-bottom: 15px;
          text-transform: uppercase;
          padding-top: 20px;
          border-top: 1px solid $c_grey_border;
        }

        &__content {
          @include font-16;

          p {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

</style>
